"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jsLoader;

var _dsCore = require("@irim/ds-core");

// js loader ability
// @author Pluto <huarse@gmail.com>
// @create 2020/01/12 16:53
const CACHE_STORE = {};
/** @type {{ [x: string]: { resolve: Function, reject: Function }[] }} */

const QUEUE_STORE = {};

function jsLoader(src, {
  timeout = 20000,
  ignoreError,
  cache = true
} = {}) {
  return new Promise((resolve, reject) => {
    const baseSrc = src.replace(/\?.*$/, '').replace(/^https?:/, '');

    if (cache && CACHE_STORE[baseSrc]) {
      _dsCore.logger.debug("".concat(baseSrc, " load success from cache"));

      return resolve(304);
    } // 队列管理，防止重复请求


    if (QUEUE_STORE[baseSrc]) {
      _dsCore.logger.debug("".concat(baseSrc, " is loading, add into queue..."));

      return QUEUE_STORE[baseSrc].push({
        resolve,
        reject
      });
    }

    QUEUE_STORE[baseSrc] = [{
      resolve,
      reject
    }];

    const handleError = message => {
      if (ignoreError) {
        QUEUE_STORE[baseSrc].forEach(x => x.resolve(0));
      } else {
        QUEUE_STORE[baseSrc].forEach(x => x.reject(new Error(message)));
      }

      QUEUE_STORE[baseSrc] = null;
    };

    let script = document.createElement('script');
    script.src = src;
    const begin = Date.now();
    let timmer = setTimeout(() => {
      script.onload = script.onerror = null;

      _dsCore.logger.warn("".concat(baseSrc, " load timeout!"));

      handleError('Script Load Timeout!');
      clear();
    }, timeout);

    const clear = () => {
      clearTimeout(timmer), timmer = null;
      document.body.removeChild(script);
      script = undefined;
    };

    script.onload = () => {
      clear();
      cache && (CACHE_STORE[baseSrc] = true);

      _dsCore.logger.info("".concat(baseSrc, " load success! use ").concat(Date.now() - begin, "ms"));

      QUEUE_STORE[baseSrc].forEach(x => x.resolve(200));
      QUEUE_STORE[baseSrc] = null;
    };

    script.onerror = () => {
      clear();

      _dsCore.logger.warn("".concat(baseSrc, " load failed"));

      handleError('Script Load Failed!');
    };

    document.body.appendChild(script);
  });
}